import { render, staticRenderFns } from "./TelemetryBrkPressFrParts.vue?vue&type=template&id=3898e133&scoped=true"
import script from "./TelemetryBrkPressFrParts.vue?vue&type=script&lang=ts"
export * from "./TelemetryBrkPressFrParts.vue?vue&type=script&lang=ts"
import style0 from "./TelemetryBrkPressFrParts.vue?vue&type=style&index=0&id=3898e133&prod&lang=scss&scoped=true"
import style1 from "./TelemetryBrkPressFrParts.vue?vue&type=style&index=1&id=3898e133&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3898e133",
  null
  
)

export default component.exports